<template>
  <div class="budget-bid-wrap">
    <div class="card-header">
      预算与出价<span class="num-text">{{ dataList.length }}/10</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" @click="newBudgetbid">新建</el-button>
      </div>
    </div>
    <div class="card-list">
      <card-item
        v-for="(item, index) of dataList"
        :key="item.itemId"
        :dataSet="item"
        :title="'新建预算包' + (index + 1)"
        @edit="editBudget"
        @copy="copyBudget"
        @del="delBudget"
        :isCur="curFormData.itemId === item.itemId"
        :showDelete="dataList.length > 1"
      ></card-item>
    </div>
    <div class="modal-body">
      <ul class="modal-form">
        <el-form :model="curFormData" :rules="rules" ref="formRef">
          <li class="form-item" style="margin-bottom: 0px" v-if="deliverySetting && deliverySetting.bid_type === 'NO_BID'">
            <span class="form-label">日预算：</span>
            <div class="form-value">
              <el-form-item prop="budget" v-if="deliverySetting.budget_optimization === 'OFF'">
                <el-input style="width: 300px" v-model="curFormData.budget" placeholder="日预算">
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
              <div v-else style="font-size: 14px; color: #999; margin-top: 6px">
                择优分配当前项目预算，<span style="font-weight: bolder; color: black">{{ deliverySetting.budget || 0 }}</span> 元/每日
              </div>
            </div>
          </li>
          <div v-else>
            <li class="form-item" style="margin-bottom: 0px">
              <span class="form-label">预算：</span>
              <div class="form-value">
                <el-form-item prop="budget">
                  <el-input style="width: 300px" v-model="curFormData.budget" placeholder="最低价">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">出价模式：</span>
              <div class="form-value">
                <el-radio-group v-model="curFormData.bid_mode">
                  <el-radio label="fixed">固定出价</el-radio>
                  <el-radio label="ladder" :disabled="isShowDeepBid">阶梯出价</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-if="curFormData.bid_mode === 'ladder'">
              <span class="form-label">出价范围：</span>
              <div class="form-value">
                <el-form-item prop="min_bid">
                  <el-input style="width: 164px" v-model="curFormData.min_bid" placeholder="最低价">
                    <template slot="append">CNY</template>
                  </el-input>
                  <span style="margin: 0 20px">—</span>
                  <el-input style="width: 164px" v-model="curFormData.max_bid" placeholder="最高价">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>

                <div class="form-value" style="margin-top: 12px">
                  <el-radio-group v-model="curFormData.bid_type">
                    <el-radio label="random">随机出价</el-radio>
                    <el-radio label="fixed">固定步长</el-radio>
                  </el-radio-group>
                </div>
                <span style="margin-top: 8px; font-size: 12px; color: #999"
                  >最终会取最高值与最低值后，再根据单次批量创建的计划数计算并平均分配出价</span
                >
              </div>
            </li>
            <div v-else>
              <li class="form-item">
                <span class="form-label">出价：</span>
                <div class="form-value">
                  <el-form-item prop="cpa_bid">
                    <el-input style="width: 300px" v-model="curFormData.cpa_bid" placeholder="出价">
                      <template slot="append">CNY</template>
                    </el-input>
                  </el-form-item>
                </div>
              </li>
              <li class="form-item" v-if="isShowDeepBid">
                <span class="form-label">深度优化出价：</span>
                <div class="form-value">
                  <el-form-item prop="deep_cpabid">
                    <el-input style="width: 300px" v-model="curFormData.deep_cpabid" placeholder="深度优化出价">
                      <template slot="append">CNY</template>
                    </el-input>
                  </el-form-item>
                </div>
              </li>
            </div>
          </div>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import CardItem from "./common/cardItem.vue";
import { mapState } from "vuex";
export default {
  components: {
    CardItem,
  },
  data() {
    return {
      tableData: [],
      dataList: [],
      curFormData: {},
      rules: {
        cpa_bid: [
          {
            trigger: ["blur"],
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("不能为空"));
              } else if (!/^[0-9]+.?[0-9]*$/.test(value) || Number(value) < 0.1) {
                callback(new Error("请输入不小于0.1的数字"));
              } else {
                callback();
              }
            },
          },
        ],
        deep_cpabid: [
          {
            trigger: ["blur"],
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("不能为空"));
              } else if (!/^[0-9]+.?[0-9]*$/.test(value) || Number(value) < 0.1 || Number(value) > 10000) {
                callback(new Error("请输入0.1~10000的数字"));
              } else {
                callback();
              }
            },
          },
        ],
        budget: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("不能为空"));
              } else if (!/^[0-9]+.?[0-9]*$/.test(value) || Number(value) < 300) {
                callback(new Error("请输入不小于300的数字"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        min_bid: [
          {
            validator: (rule, value, callback) => {
              if (!this.curFormData.max_bid || !value) {
                callback(new Error("最低价和最高价不能为空"));
              } else if (
                !/^[+-]?(\d|([1-9]\d+))(\.\d+)?$/.test(this.curFormData.max_bid) ||
                !/^[+-]?(\d|([1-9]\d+))(\.\d+)?$/.test(value) ||
                Number(value) > Number(this.curFormData.max_bid)
              ) {
                callback(new Error("最低价和最高价为数字,且最低价不大于最高价"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 3600 * 24 * 1000;
        },
      },
    };
  },
  mounted() {
    this.newBudgetbid();
  },
  methods: {
    newBudgetbid() {
      if (this.dataList.length >= 10) {
        return;
      }
      let newItem = {
        itemId: Math.random(),
        name: "预算包" + (this.dataList.length + 1),
        budget: null,
        bid_mode: "fixed",
        min_bid: null,
        max_bid: null,
        bid_type: "fixed",
        cpa_bid: null, //出价
      };
      this.dataList.push(newItem);
      this.editBudget(newItem);
      this.saveListInStore();
    },
    editBudget(dataItem) {
      this.curFormData = dataItem;
    },
    copyBudget(dataItem) {
      if (this.dataList.length >= 10) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(dataItem));
      copyData.itemId = Math.random();
      copyData.name = copyData.name + "_复制";
      this.dataList.push(copyData);
      this.saveListInStore();
    },
    delBudget(dataItem) {
      let curIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(curIndex, 1);
      this.saveListInStore();
    },
    //格式化单条表单数据
    formatData(storeData) {
      storeData.budget === "" && (storeData.budget = null);
      storeData.cpa_bid === "" && (storeData.cpa_bid = null);
    },
    transforApiToForm(item) {
      item.itemId = item.itemId || Math.random();
      if (!item.bid_mode) {
        item.bid_mode = "fixed";
      }
      if (!item.bid_type) {
        item.bid_type = "fixed";
      }
      if (!item.min_bid) {
        item.min_bid = null;
      }
      if (!item.max_bid) {
        item.max_bid = null;
      }
    },
    saveListInStore() {
      //保存到store
      let storeDataList = JSON.parse(JSON.stringify(this.dataList));
      storeDataList.forEach((storeData) => {
        this.formatData(storeData);
      });
      this.$store.commit("set_budget_and_bid_ttV2", storeDataList);
    },
    //保存模板时不校验，直接保存
    saveData() {
      this.saveListInStore();
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];
            if (!item.cpa_bid && item.bid_mode === "fixed" && !item.budget) {
              pass = false;
              this.editBudget(item);
              this.$nextTick(() => {
                this.$refs.formRef.validate(() => {});
              });
              break;
            }
          }
          if (pass) {
            this.saveData();
            resolve();
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
  },
  computed: {
    ...mapState({
      budgetBids: (state) => state.PromotionTtV2.budgetBids,
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      targeting: (state) => state.PromotionTtV2.targeting,
      deliverySetting: (state) => state.PromotionTtV2.deliverySetting,
      optimizeGoal: (state) => state.PromotionTtV2.optimizeGoal,
    }),
    isShowDeepBid() {
      return this.optimizeGoal && this.optimizeGoal.deep_external_action && this.optimizeGoal.deep_external_action !== "NONE";
    },
  },
  watch: {
    budgetBids(value) {
      if (value) {
        let copyList = JSON.parse(JSON.stringify(value));
        //还原表格数据
        copyList.forEach((item) => {
          this.transforApiToForm(item);
        });
        this.dataList = copyList;
        if (this.dataList.length > 0) {
          //聚焦最后一个
          this.editBudget(this.dataList[this.dataList.length - 1]);
        }
      }
    },
    "optimizeGoal.deep_external_action": {
      handler() {
        if (this.isShowDeepBid) {
          this.curFormData.bid_mode = "fixed";
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.budget-bid-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .modal-body {
    padding-top: 10px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 12px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 100px;
          text-align: right;
          font-size: 14px;
          padding-top: 8px;
          color: rgba(0, 0, 0, 0.65);
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
        }
      }
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
}
</style>
